<template lang="pug">
  footer
</template>

<script>
export default {
  name: 'Footer'
};
</script>

<style lang="sass" nolang="scss" scoped>
  footer
    @apply mt-6
</style>
